import { createGlobalStyle } from 'styled-components';
import { Theme } from '@web-chat-core/ui-kit';

const GlobalStyle = createGlobalStyle<{ theme: Theme }>`
    @supports not selector(::-webkit-scrollbar) {
        html {
            /* Scrollbar new syntax for FF */
            scrollbar-color: ${(props) => props.theme.root.colors.basicColors['10%']} transparent;
            scrollbar-width: 6px;
        }
    }

    body {
        padding: 0;
        font-family: ${(props) => props.theme.fontFamily};
        font-variant-ligatures: common-ligatures;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: white;
        margin: 0;
        height: 100vh; /* Fallback для браузеров, которые не поддерживают dvh */
        height: 100dvh;
        font-size: 12px;
        background-color: ${(props) => props.theme.root.colors.background['01Base']};
    }

    code {
        font-family: Roboto Mono, ${(props) => props.theme.fontFamily};
    }

    a {
        color: #5a8bff;
    }

    a:hover {
        opacity: 0.8;
    }

    /**
     * 1. Change the font styles in all browsers.
     * 2. Remove the margin in Firefox and Safari.
     */
    
    button,
    input,
    optgroup,
    select,
    textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
    margin: 0; /* 2 */
    }

    *::-webkit-scrollbar {
        width: 6px;
        height: 8px;
    }

    *::-webkit-scrollbar-thumb {
        background-color: ${(props) => props.theme.root.colors.basicColors['10%']};
        border-radius: 10px;
    }

    *::-webkit-scrollbar-track {
        background-color: transparent;
    }

    :root {
        --layout-grid-gap: 8px;
        --desktop-footer-height: 88px;
        --desktop-padding: 12px;

        --mobile-portrait-padding-top: 12px;
        --mobile-portrait-padding-right: 10px;
        --mobile-portrait-padding-bottom: 0px;
        --mobile-portrait-padding-left: 10px;
        --mobile-landscape-padding: 8px;
    }
`;

export default GlobalStyle;
